import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
declare var $: any;
import { TreeService } from '../tree/tree.service';
import { SharedService } from 'src/app/dce-service/shared.service';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class TreeComponent implements OnInit, AfterViewInit, OnChanges {

	//	Variables Initialised

  	@Input() case: string;
  	@Input() tree_id: string;
  	@Input() id: string;
    @Input() search_placeholder: string = "Search within Hierarchy";
    @Input() plugins?: any = []

    @Output() tree_event: EventEmitter<any> = new EventEmitter<any>();
    @Output() move_node_event: EventEmitter<any> = new EventEmitter<any>();
    // @ViewChild('mainScreen') elementView: ElementRef;

  	menu_map = {

      "busorgdetails": {
        "menu": {
          "biz_org": {
            "4__4001": "add_new_division",/*add_new_division*/
          },
          "div_org": {
            "36__44005": "",/*add_new_division*/
            "36__44006": "",/*remove_division*/
          }
        },
        "service": "get_tree_biz",
      },

      "busorgdetails_division": {
        "menu": {
          "biz_org": {
            "36__44001": "",/*add_new_division*/
          },
          "div_org": {
            "7__7001": "add_new_division",/*add_new_division*/
            "7__7002": "remove_division",/*remove_division*/
          },
          "no_context": {}
        },
        "service": "get_tree_biz",
      },

      "busorgdetails_employee": {
        "menu": {
          "biz_org": {
            "36__44001": "",/*add_new_division*/
          },
          "div_org": {
            "36__44005": "",/*add_new_division*/
            "36__44006": "",/*remove_division*/
          }
        },
        "service": "get_tree_biz",
      },

      'sitedetails' : {
        "menu": {
          "biz_org": {
            "14__14001": "add_new_site",
            "36__44002": "",/*add_contact*/
          },
          "site_leaf": {
            "36__44005": "",/*add_new_site*/
            "36__44006": "",/*add_contact*/
          },
          "site_non_leaf": {
            "36__44005": "",/*add_new_site*/
            "36__44006": "",/*add_contact*/
          },
          "contact_rec": {
            "36__44005": "",/*add_new_site*/
            "36__44006": "",/*add_contact*/
          }
        },
        "service": "get_tree_biz_site",
      },

      'sitedetails_location' : {
        "menu": {
          "biz_org": {
            "36__44001": ""
          },
          "site_leaf": {
            "17__17001": "add_new_site",
            "17__17002": "remove_site",
            "17__17003": "add_contact"
          },
          "site_non_leaf": {
            "17__17002": "remove_site",
            "17__17001": "add_new_site"
          },
          "contact_rec": {}
        },
        "service": "get_tree_biz_site",
      },
      'sitedetails_contact' : {
        "menu": {
          "biz_org": {
            "36__44001": ""
          },
          "site_leaf": {
            "36__44006": ""
          },
          "site_non_leaf": {
            "36__44006": ""
          },
          "contact_rec": {}
        },
        "service": "get_tree_biz_site",
      },
      "employeedetails": {
        "menu": {
          "biz_org": {
           "38__46001" : "",/*add_new_division*/
          },
          "div_org": {
            "38__46004" : "",/*add_new_division*/
            "38__46005" : "",/*remove_division*/
          }
        },
        "service": "get_tree_biz",
      },

      "classification": {
        "menu": {
          "root_class": {
            "26__26001":"add_sub_classification"
          },
          "sub_class": {
            "26__26001" : "add_sub_classification",
            "26__26002" : "remove_classification"
          }
        },
        "plugins":["types", "contextmenu", "search","dnd"],
        "service": "get_classification_tree",
      },
      

      "discipline_classification": {
        "menu": {
          "root_class": [],
          "sub_class": [],
          "leaf_class": []
        },
        "service": "get_internal_class_priority_severity",
      },

      "mobile_classification": {
        "menu": {
          "no_leaf": [],
          "mapped_leaf": [],
          "no_mapped_leaf": []
 
          
        },
        "service": "get_mobile_classification_mapping",
      },
      
      'asidetails_division' : {
        "menu": {
          "asi_biz": {
            "37__37001":"add_new_department"
          },
          "asi_div": {
            "37__37001":"add_new_department",
            "37__37002": "remove_department"
          },
          "asi_div_leaf": {
            "37__37001":"add_new_department",
            "37__37002":"remove_department", 
            "37__37003":"add_new_employee"
          },
          "asi_emp": []
        },
        "service": "get_internal_org_employee_tree"
      },
      'asidetails_employee' : {
        "menu": {
          "asi_biz": [],
          "asi_div": [],
          "asi_div_leaf": [""],
          "asi_emp": [""]
        },
        "service": "get_internal_org_employee_tree"
      },
      "bizorg_productmap": {
        "menu": {
          'biz_org':{
            "41_00001":""
          },
          "product_type": {
            "41_00001":""
          },
          "product_house": {
            "41_10001": "",
          },
          "product": {
            "73__73001": "remove_prod",
          },
          "fund_description":{
            "41_10001": "",
          },
          "eb_without_json": {
            "73__73005": "add_eb_json",
            // "73__73001": "remove_prod",
          },
          "eb_with_json": {
            "73__73004": "update_eb_json",
            // "73__73001": "remove_prod",
          },
        },
        "service": "get_biz_prod_tree",
      },
      "portfolio-manager": {
        "menu": {},
        "service": "portfolio/get_portfolio_Tree",
      },
      "customer_management_tree":{
        "menu": {
          "biz": [
            // "add_location",
            // "create_division",
            "add_contact_biz",
            "create_child_biz_org"
          ],
          "sub_biz_org": [
            "create_child_biz_org",
            "create_division",
            "add_location",
            "add_contact_biz"
          ],
          "site_leaf": [
            "add_location",
            "remove_location",
            "add_contact_site"
          ],
          "site_non_leaf": [
            "add_location",
            "remove_location"
          ],
          "site": [
            "add_location",
            "remove_location"
          ],
          "contact_rec": [
            "view_contact"
          ],
          "contact_static_biz": [
            "add_contact_biz"
          ],
          "contact_static_div": [
            "add_contact_div"
          ],
          "contact_static_site": [
            "add_contact_site"
          ],
          "division": [
            "add_sub_division",
            "remove_division"
          ],
          "division_leaf": [
            "add_sub_division",
            "remove_division",
            "add_contact_div"
          ],
          "sub_div_org": [
            "add_sub_division",
            "remove_division"
          ]
        },
        "service": "customer_management/tree"
      },
      "internal_org_management_tree": {
        "menu": {
          "biz": {},
          "biz_static": {
            "4__4001": "add_sub_bizorg",
          },
          "div_static":{
            "4__4001": "create_division",
          },
          "division": {
            "36__44005": "add_sub_division",/*add_new_division*/
            "36__44006": "remove_division"
          },
          "division_leaf": {
            "36__44005": "add_sub_division",/*add_new_division*/
            "36__44006": "remove_division",
            "37__37003":"add_new_employee"
          },
        },
        "service": "int_org_management/tree",
      },
      "tenant_knowledge_management" : {
        "menu": {},
        "service": "tenant/data/jstree",
      },
      "tenant_notification": {
        "menu": {},
        "service": "tenant/data/jstree",
      },
      "tenant_dispatch_rule": {
        "menu": {},
        "service": "tenant/data/jstree",
      },
      "tenant_email_template": {
        "menu": {},
        "service": "tenant/data/jstree",
      },
      "tenant_user_roles": {
        "menu": {},
        "service": "tenant/data/jstree",
      }
  	}
    
    context_menu_items_map = {
      "add_new_site": "Add Location",
      "remove_site": "Remove Location",
      "add_location": "Add Location",
      "remove_location": "Remove Location",
      "add_contact": "Add Contact",
      "add_contact_biz": "Add Contact",
      "add_contact_div": "Add Contact",
      "add_contact_site": "Add Contact",
      "add_new_division": "Add Division",
      "create_division": "Add Division",
      "add_sub_division": "Add Division",
      "remove_division": "Remove Division",
      "add_new_department": "Add Department",
      "remove_department": "Remove Department",
      "add_sub_classification": "Add Sub Classification",
      "remove_classification": "Remove Classification",
      "add_new_employee": "Add Employee",
      "remove_employee": "Remove Employee",
      "update_employee": "Update Employee",
      "remove_prod_house": "Remove Product House",
      "remove_prod": "Remove Product",
      "add_eb_json": "Add Employee Benefits",
      "update_eb_json": "Update Employee Benefits",
      "add_sub_bizorg": "Add Organisation",
      "create_child_biz_org": "Add Organisation",
    }

  	menu_items = {};
  	service = '';

		icon_types: any = {
			"default" : {
				"icon" : "jstree-remove-icon"
			},
      "biz_org" : {
        "icon" : "jstree-remove-icon"
      },
      "div_org" : {
        "icon" : "jstree-remove-icon"
      },
			"root_class" : {
				"icon" : "jstree-remove-icon"
			},
			"sub_class" : {
				"icon" : "jstree-remove-icon"
			},
      "asi_biz" : {
        "icon" : "i-Building"
      },
      "asi_div" : {
        "icon" : "i-Conference"
      },
      "asi_div_leaf" : {
        "icon" : "i-Conference"
      },
      "asi_emp" : {
        "icon" : "i-Administrator"
      },
      "site_leaf" : {
        "icon" : "i-Map-Marker"
      },
      "site_non_leaf" : {
        "icon" : "i-Map-Marker"
      },
      "contact_rec" : {
        "icon" : "i-Administrator"
      },
      "product_house" : {
        "icon" : "jstree-remove-icon"
      },
      "product" : {
        "icon" : "jstree-remove-icon"
      },
      "eb_with_json" : {
        "icon" : "i-Yes"
      },
      "eb_without_json" : {
        "icon" : "i-Close-Window"
      },
      "mapped_leaf" : {
        "icon" : "i-Yes"
      },
      "no_mapped_leaf" : {
        "icon" : "i-Close-Window"
      },
		}

    tree_data = [];
    tree_height = '';
    role_map = {};

	constructor(
		private _sharedService: SharedService,
		private _tree_service: TreeService
		) {

  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes.id && !changes.id.firstChange) {
      this._update_tree_data(this.case, this.tree_id, changes.id.currentValue);
    }
    if(changes.plugins) {
      this.menu_map[this.case]['plugins'] = changes.plugins.currentValue;
    }
  }

	ngOnInit() {
		var self = this;
    this.role_map = this._sharedService.get_roles_map();
    this._get_tree_data();
  }

  ngAfterViewInit() {
    this.onResize('');
  }

  // @HostListener('window:scroll', [])
  // onScroll(event): void {
  //   localStorage.setItem(this.tree_id, event.srcElement.scrollTop);
  // }

  onResize(event) {
    // 20 value for the margin bottom 
    if ($('.top-position').offset() != undefined) {
      const w = window.innerHeight - $('.top-position').offset().top - 20;
      const divHeight = w.toString() + 'px' ;
      document.getElementById(this.tree_id).setAttribute('style', `height:${divHeight}`);
    }
  }

	  jsTree(tree_id, tree_data){

    var to: any = false;

    $('#search_'+tree_id).keyup(function() {
      if (to) {
        clearTimeout(to);
      }
      to = setTimeout(function() {
        var v = $('#search_'+tree_id).val();
        $('#'+tree_id).jstree(true).search(v);
      }, 250);
    });

    tree_id = tree_id;
    // tree_id = 'js_tree_id';
		var self = this;
		// alert(self);
		// console.log(tree_data);
		var main_tree = $('#'+tree_id).jstree({
			'core' : {
				'data' : tree_data,
        "check_callback": function (op, node, par, pos, more) {
          if(more && more.dnd && (op === 'move_node') && node.parent != par.id) {
             return false;
           }
           return true;
         },
				'themes': {
          'name': 'proton',
          'responsive': true,
					'icons': true
				}
			},
      "plugins": this.menu_map[this.case]['plugins']? this.menu_map[this.case]['plugins']:["types", "contextmenu", "search"],
      "search": {
        "show_only_matches": true,
        "show_only_matches_children": true,
      },
			// "plugins": ["contextmenu"],
      "types" : this.icon_types,
			"contextmenu": {
		    "items": function(node) {
          console.log(node)
          return self.context_menu_options(self, node);
        }
	    }

		}).bind("select_node.jstree", function (evt, data){
			self.left_click_options(self, data);
    }).bind("move_node.jstree", function(e, data) {
      //console.log(data.old_position + '->' + data.position);
      //console.log(data.node.id + '->' + data.position);
      //console.log(index_difference);
      // console.log(children);
      // const index_difference = data.position -data.old_position
      // if(index_difference >0) {
      //   console.log("uper se niche")
      // } else {
      //   console.log("niche se uper")
      // }
      const children = $('#' + self.tree_id).jstree().get_node(data.parent).children;
      const old_index_node = $('#' + self.tree_id).jstree().get_node(children[data.position +1])
      self.move_node_event.emit({drop_node: old_index_node, selected_node: data.node, selected_node_index:data.old_position});
    });

    this.tree_event.emit({'case': 'tree_loaded', 'data': {} });

  }

  //	FUNCTIONS

  context_menu_options(self, node){
  	// var tree = $("#"+tree_id).jstree(true);	//	IMPORTANT

    var final_items = {};

    var items = {};
    for(var item in this.context_menu_items_map){
      items[item] = {
        label: this.context_menu_items_map[item],
        value: item,
        action: function (data) {
          self.tree_to_parent({'case': data.item.value, 'data': node.original});
        }
      };
    }

    for(var i=0; i<node.data.context_items.length; i++) {
    	final_items[node.data.context_items[i]] = items[node.data.context_items[i]];
    }

    return final_items;

  }

  left_click_options(self, data){
    console.log(data);
    var internal_case = data.node.original.type;
    self.tree_to_parent({'case': self.case + '_left_' + internal_case , 'data': data.node.original, 'level':data.node.parents.length});

  }

  tree_to_parent(data: any): void {
      this.tree_event.emit(data);
  }

  _get_tree_data() {
  	this.update_menu_items();

    this._tree_service.get_tree_data(this.service, this.id, this.menu_items).subscribe(
      res => {
        if (res.errCode != undefined && res.errCode == 0) {
          this.tree_data = res.data;
        } else {
          this.tree_data = res;
        }
        // this.tree_data = [
        //   {"id": 127096, "parent": "#", "text": "Moses App Case Classification V1", "state": {"opened": true}, "data": {"context_items": []}, "type": "no_leaf", "mapped_data": null},
        //   {"id": 127097, "parent": 127096, "text": "Healthcare", "state": {"opened": true}, "data": {"context_items": []}, "type": "no_leaf", "mapped_data": null},
        //   {"id": 127120, "parent": 127097, "text": "Membership Termination", "state": {"opened": true}, "data": {"context_items": []}, "type": "mapped_leaf", "mapped_data": {"mobile_classification_id": 127120, "case_classification_id": 128243, "app_username": "sys_admin@alteram.com"}}]
        this.jsTree(this.tree_id, this.tree_data);
      },
      err => {
        console.log(err)
      }
    );

  }
  _get_tree_length(){
    this.tree_to_parent({'case':'tree_length','data':this.tree_data.length});   
  }
  _update_tree_data(case_type, tree_id, id) {
  	this.case = case_type;
  	this.tree_id = tree_id;
  	this.id = id;

  	this.update_menu_items();

	    this._tree_service.get_tree_data(this.service, this.id, this.menu_items).subscribe(
	      res => {
          if (res.errCode != undefined && res.errCode == 0) {
            this.tree_data = res.data;
          } else {
            this.tree_data = res;
          }
	        // console.log(this.tree_data);
	        // console.log($('#'+ this.tree_id).jstree(true));
	        $('#'+ this.tree_id).jstree(true).settings.core.data = this.tree_data;
					$('#'+ this.tree_id).jstree(true).refresh();
	      },
	      err => {
	        console.log(err)
	      }
	    );

  }

  update_menu_items(){
  	this.menu_items = this.filter_menu_by_role(this.menu_map[this.case]['menu']);
  	this.service = this.menu_map[this.case]['service'];

  }

  filter_menu_by_role(menu_items){
    // return menu_items;
    var return_menu_obj = {};
    for (var type in menu_items) {
      return_menu_obj[type] = [];
      for (var role_key in menu_items[type]) {
        if(this.fetch_role(role_key) == 1){
          return_menu_obj[type].push(menu_items[type][role_key]);
        } else {
          // skip adding to menu
        }
      }
    }

    return return_menu_obj;
  }

  fetch_role(key){
    var param = key.split("__");
    if(this.role_map[param[0]] != undefined && this.role_map[param[0]][param[1]] != undefined){
      return this.role_map[param[0]][param[1]];
    } else {
      return 1;
    }
  }

  update_tree_data_local() {
    $('#'+ this.tree_id).jstree(true).settings.core.data = this.tree_data;
    $('#'+ this.tree_id).jstree(true).refresh();
  }
  
  tree_state_close() {
    $('#'+ this.tree_id).jstree("close_all");
  }

  tree_state_open() {
    $('#'+ this.tree_id).jstree("open_all");
  }

  add_new_node_local(object){
    // add new node to this.tree_data
    object['data'] = {"context_items": this.menu_map[this.case]['menu'][object.type]};
    object['state'] = {"opened": true};
    this.tree_data.push(object);
    this.update_tree_data_local();
  }

  // update_node_local(id, object){
  //   // update node in this.tree_data
  //   for(var i=0; i<this.tree_data.length; i++){
  //     if(this.tree_data[i]['id'] == id){
  //       object['data'] = {"context_items": this.menu_map[this.case]['menu'][object.type]};
  //       this.tree_data[i] = object;
  //     }
  //   }
  //   this.update_tree_data_local();
  // }
  
  update_node_text_local(id, text){
    // update node in this.tree_data
    for(var i=0; i<this.tree_data.length; i++){
      if(this.tree_data[i]['id'] == id){
        this.tree_data[i]['text'] = text;
        break;
      }
    }
    this.update_tree_data_local();
  }

  remove_node_local(id){
    this.remove_nodes_recursive(id);
    this.update_tree_data_local();
  }

  remove_nodes_recursive(id){
    var children = [];
    var index_to_remove = -1;
    for(var i=0; i<this.tree_data.length; i++){
      if(this.tree_data[i]['id'] == id){
        index_to_remove = i;
      }
      if(this.tree_data[i]['parent'] == id){
        children.push(this.tree_data[i]['id']);
      }
    }
    if(children.length){
      for(var j=0; j<children.length; j++){
        this.remove_nodes_recursive(children[j]);
      }
    }

    this.tree_data.splice(index_to_remove, 1);

  }

  select_node(id, supress_event = false) {
    setTimeout( () => { 
      $('#' + this.tree_id).jstree('select_node', id, supress_event);
      // $('#' + this.tree_id).animate( {scrollTop : localStorage.getItem(this.tree_id) }, 600 )
    }, 500);
  }

  unselect_all_node(){
    $('#' + this.tree_id).jstree('deselect_all', true);
  }

  get_node_name(id,_case) {
    setTimeout( () => {
      var node = $('#' + this.tree_id).jstree().get_node(id).text; 
      this.tree_to_parent({'case':_case,'data':node});   
    },500);
  }

  reset_tree_node() {
    $('#'+ this.tree_id).jstree().refresh();
  }

  get_node_data_by_node_id(id){
    let data:any = null
    for(var i=0; i<this.tree_data.length; i++){
      if(this.tree_data[i]['id'] == id){
        data = this.tree_data[i]
        break
      }
    }

    return data
  }

  get_immediate_parent(parent_id) {
    let parent_dict = null;
    for (let i = 0; i < this.tree_data.length; i++) {
      if (this.tree_data[i].id == parent_id) {
        parent_dict = this.tree_data[i];
        break;
      }
    }
    return parent_dict;
  }

  get_immediate_child(node_id) {
    let child_dict = null;
    for (let i = 0; i < this.tree_data.length; i++) {
      if (this.tree_data[i].parent == node_id) {
        child_dict = this.tree_data[i];
        break;
      }
    }
    return child_dict;
  }

  get_parent_by_type(_case, parent_id, node_type, parent_list = []) { // _case first/all
    for (let i = 0; i < this.tree_data.length; i++) {
      if (this.tree_data[i].id == parent_id) {
        if (this.tree_data[i].type === node_type) {
          parent_list.push(this.tree_data[i]);
          if (_case == 'first') {
            return parent_list;
          }
        }
        this.get_parent_by_type(_case, this.tree_data[i].parent, node_type, parent_list);
        break;
      }
    }
    return parent_list;
  }

  get_all_children_by_type(node_id, node_type, children_list = []) {
    for (let i = 0; i < this.tree_data.length; i++) {
      if (this.tree_data[i].parent == node_id) {
        if (this.tree_data[i].type == node_type) {
          children_list.push(this.tree_data[i]);
        }
        this.get_all_children_by_type(this.tree_data[i].id, node_type, children_list);
      }
    }
    return children_list;
  }

  // method will take json and insert node in tree
  insert_node_json_in_tree(json) {
    // this.tree_data.push(json);
    // for fail-safe iterate tree list to find parent.
    for (let i = 0; i < this.tree_data.length; i++) {
      if (this.tree_data[i].id === json.parent) {
        this.tree_data.push(json);
        break;
      }
    };
    this.update_tree_data_local();
  }

  update_tree_node_local(node_id, node_text) {
    for (let i = 0; i < this.tree_data.length; i++) {
      if (this.tree_data[i].id === node_id) {
        this.tree_data[i].text = node_text;
        break;
      }
    };
   this.update_tree_data_local();
  }

  update_tree_node_object_local(node_id, node_data) {
    this.tree_data = this.tree_data.map(data => {
      return data.id === node_id ? { ...node_data } : data
    });
    this.update_tree_data_local();
  }

}
